import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../../app/i18n";
import { LeadsPage } from "../../../../areas/seller/leads/LeadsPage";
import type { LeadsSearch } from "../../../../areas/seller/leads/search";

/**
 * FE-18 lead dossiers: filters, sort and admin scope live in the URL (§6.1). Validation here only
 * types the params (the full check, `parseLeadsSearch`, runs in the lazy screen) so the entry
 * chunk does not carry the leads vocabulary.
 */
export const Route = createFileRoute("/app/_seller/leads/")({
  validateSearch: (search: Record<string, unknown>) => search as LeadsSearch,
  beforeLoad: () => loadNamespaces("leads"),
  component: LeadsPage,
});
